export const apiConstants = {
  // Common variables

  LOGIN_BY: "manual",

  DEVICE_TYPE: "web",

  DEVICE_TOKEN: "123456",

  ERROR_CODE: [1000, 1001, 1002, 1003, 1004, 1005, 1006],

  google_api_key: "AIzaSyBwMhGADzGH8vWuzlxkTzL0JrvxVPAHtiY",

  settingsUrl:
    "https://cms.onlyally.com/api/user/get_settings_json",

  firebase_api_key: "AIzaSyBoHjrDF2ZYTIOoyuVyV4YgIgpx5W46PiM",

  firebase_auth_domain: "fansclub-295709.firebaseapp.com",

  firebase_project_id: "fansclub-295709",

  firebase_storage_bucket: "fansclub-295709.appspot.com",

  firebase_messaging_sender_id: "36578671417",

  firebase_app_id: "1:36578671417:web:9b3caa70fac5d876bdc6e8",

  firebase_measurement_id: "G-9TEV8L7EW7",

  firbase_public_key:
    "BLUNv9ZktZ9_PdWH4FRgDGvX2AfABbdKIse2sIsO8ipaeEtLe_rZG2lYF8tyPvDLDk08t-8aqO6VQGij_p1t2uQ",
};
